<template lang="pug">
  d2-container
    .mod-role
    el-row()
      el-col(:span='24')
        el-form(:inline='true', :model='dataForm', size='mini', @keyup.enter.native='getDataList()')
          el-form-item(label="角色名称:")
            el-input.inputWidth(v-model='dataForm.roleName', placeholder='角色名称', clearable='')
    el-row(style="padding-bottom:15px;" ,:span="24")
      el-col(:md='23')
        el-button(v-if="isAuth('sys:role:save')", type='primary', @click='addOrUpdateHandle()') 新增
        el-button(v-if="isAuth('sys:role:delete')", type='danger', @click='deleteHandle()', :disabled='dataListSelections.length <= 0') 删除
      el-col(:span='1' style='float:right;')
        el-button(@click='getDataList()',icon='el-icon-search',type='primary',style='float:right;') 查询
    el-table(:data='dataList', border='', v-loading='dataListLoading', @selection-change='selectionChangeHandle', style='width: 100%;')
      el-table-column(type='selection', header-align='center', align='center', width='50')
      el-table-column(prop='roleName', header-align='center', align='center', label='角色名称')
      el-table-column(prop='remark', header-align='center', align='center', label='角色描述')
      //- el-table-column(fixed='right', header-align='center', align='center', width='150', label='操作')
      //-   template(slot-scope='scope')
      //-     el-button(v-if="isAuth('sys:role:update')", type='text', size='small', @click='addOrUpdateHandle(scope.row.roleId)') 修改
      //-     el-button(v-if="isAuth('sys:role:delete')", type='text', size='small', @click='deleteHandle(scope.row.roleId)') 删除
      el-table-column(prop='',header-align='center',align='center',label='操作',width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('sys:role:update')",  @click="addOrUpdateHandle(scope.row.roleId)") 修改
                                el-menu-item(index="1-2" v-if="isAuth('sys:role:delete')",  @click="deleteHandle(scope.row.roleId)") 删除

    el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
    add-or-update(v-if='addOrUpdateVisible', ref='addOrUpdate', @refreshdatalist='getDataList')
</template>

<script>
import AddOrUpdate from './role-add-or-update'
export default {
  name: 'sys-role',
  data () {
    return {
      isCollapse: true,
      dataForm: {
        roleName: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/sys/role/list'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'roleName': this.dataForm.roleName
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.roleId
      })
      this.$confirm(`是否删除角色？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal:false
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/sys/role/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style >
  /* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';
 .inputWidth{
  width: 210px;
}
</style>
